import {
  Box,
  Checkbox,
  CircularProgress,
  Container,
  Grid,
  Slider,
  styled,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import Header from "../../Components/Layout/Header";
import pic from "../Assets/landing/Art Wall Logo.png";
import styles from "./OnlinePrinting.module.css";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ReactCrop, { type Crop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Parse from "../../API/ParseServer";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../../Components/Layout/Footer";
import { useCart } from "../../Context/CartContext";

const zoomBoxShadow =
  "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";

const ZoomSlider = styled(Slider)(({ theme }) => ({
  color: "#cccccc",
  height: 20,
  borderRadius: "5px",
  padding: "15px 0",
  "& .MuiSlider-thumb": {
    borderRadius: "5px",

    height: 25,
    width: 30,
    backgroundColor: "#fff",
    boxShadow: "0 0 2px 0px rgba(0, 0, 0, 0.1)",
    "&:focus, &:hover, &.Mui-active": {
      boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.1)",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: zoomBoxShadow,
      },
    },
    "&:before": {
      boxShadow:
        "0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)",
    },
  },
  "& .MuiSlider-valueLabel": {
    fontSize: 10,
    fontWeight: "normal",
    top: -6,
    backgroundColor: "white",
    border: "1px solid gray",
    borderRadius: "5px",

    color: theme.palette.text.primary,
    "&::before": {
      display: "none",
    },
    "& *": {
      background: "transparent",
      color: theme.palette.mode === "dark" ? "#fff" : "#000",
    },
  },
  "& .MuiSlider-track": {
    border: "none",
    height: 20,
  },
  "& .MuiSlider-rail": {
    opacity: 0.5,
    boxShadow: "inset 0px 0px 4px -2px #000",
    backgroundColor: "white",
    border: "1px solid gray",
  },
}));
function reduce(numerator: any, denominator: any) {
  var gcd: any = function gcd(a: any, b: any): any {
    return b ? gcd(b, a % b) : a;
  };
  gcd = gcd(numerator, denominator);
  return [numerator / gcd, denominator / gcd];
}

const OnlinePrinting = () => {
  const [userArtwork, setUserArtwork] = useState<any>();
  const [pictureUrl, setPictureUrl] = useState("");
  const [picture, setPicture] = useState<any>();
  const [widthError, setWidthError] = useState("");
  const [heightError, setHeightError] = useState("");

  const [inputWidth, setInputWidth] = useState(0);
  const [inputHeight, setInputHeight] = useState(0);
  // const [width, setWidth] = useState(0);
  // const [height, setHeight] = useState(0);
  const [wdpi, setWdpi] = useState(100);
  const [hdpi, setHdpi] = useState(100);
  const [title, setTitle] = useState("");
  const [result, setResult] = useState<any>();
  const [fetchLoading, setFetchLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  // const [artworkId, setArtworkId] = useState("");

  const [crop, setCrop] = useState<Crop>({
    unit: "%", // Can be 'px' or '%'
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  });
  const [selectedPaper, setSelectedPaper] = useState("Satin Photo Paper");
  const navigate = useNavigate();
  const [pricing, setPricing] = useState<any>();
  const params = useParams();
  const [widthRealFactor, setWidthRealFactor] = useState(1);
  const [heightRealFactor, setHeightRealFactor] = useState(1);
  const { setTotalQuantity } = useCart();
  useEffect(() => {
    const fetchArtworkById = async (artworkId: string) => {
      setWidthError("");
      setHeightError("");
      setFetchLoading(true);
      const query = new Parse.Query("UserArtwork");
      try {
        const artwork = await query.get(artworkId);
        console.log(artwork.get("image").url());
        setUserArtwork(artwork);
        setPictureUrl(artwork.get("image").url());

        setTitle(artwork.get("title"));
        setInputHeight(
          Number(((Number(artwork.get("height")) * 2.54) / 100).toFixed(1)),
        );
        setHdpi(100);
        setInputWidth(
          Number(((Number(artwork.get("width")) * 2.54) / 100).toFixed(1)),
        );
        setWdpi(100);
        setRatio(
          Number(((Number(artwork.get("width")) * 2.54) / 100).toFixed(1)) /
            Number(((Number(artwork.get("height")) * 2.54) / 100).toFixed(1)),
        );
        setFetchLoading(false);
      } catch (error) {
        setFetchLoading(false);

        console.error("Error fetching artwork:", error);
        setWidthError("Error fetching artwork please try again");
      } finally {
        setPicture(document.getElementById("userArtwork"));
      }
    };
    if (localStorage.getItem("uploadImageId"))
      fetchArtworkById(String(localStorage.getItem("uploadImageId")));
  }, [localStorage.getItem("uploadImageId")]);
  useEffect(() => {
    const fetchItem = async () => {
      if (params.mode === "edit" && localStorage.getItem("editItemId")) {
        const user = Parse.User.current();
        if (user || localStorage.getItem("guestId")) {
          try {
            const basket = await Parse.Cloud.run("getBasket", {
              user: user ? user.id : localStorage.getItem("guestId"),
            });

            const item = basket
              .get("items")
              .find(
                (item: any) =>
                  item.itemId === localStorage.getItem("editItemId"),
              );
            if (basket.get("status") !== "completed" && item) {
              console.log(item);
              setSelectedPaper(item.specifications.paper);
            }
            let totalQuantity = 0;
            basket.get("items").forEach((item: any) => {
              totalQuantity += item.quantity;
            });
            setTotalQuantity(totalQuantity);
            localStorage.setItem("totalQuantity", String(totalQuantity));
          } catch (error) {
            console.error("Error fetching basket:", error);
          } finally {
            // setLoading(false);
          }
        }
      }
    };
    fetchItem();
    const fetchPricing = async () => {
      const pricingQuery = new Parse.Query("Pricing");
      try {
        const results = await pricingQuery.find();
        setPricing(results[0]);
        console.log(results[0]);
      } catch (err: any) {
        // setError(err.message);
      } finally {
        // setLoading(false);
      }
    };
    fetchPricing();
  }, []);
  const paperChangeHandler = (event: any) => {
    setSelectedPaper(event.target.id);
  };
  const [frame, setFrame] = useState("No Frame");
  const frameChangeHandler = (event: any) => {
    setFrame(event.target.id);
  };
  const [ratio, setRatio] = useState(0);

  const cropHandler = (c: any) => {
    setCrop(c);
    if (!forceFit) {
      setWidthError("");
      setHeightError("");
      if (
        Number(((Number(c.width) * 2.54) / 100).toFixed(1)) /
          Number(((Number(c.height) * 2.54) / 100).toFixed(1)) !==
        ratio
      ) {
        setInputHeight(
          Number(
            (((Number(c.height) * 2.54) / 100) * heightRealFactor).toFixed(1),
          ),
        );
        setInputWidth(
          Number(
            (((Number(c.width) * 2.54) / 100) * widthRealFactor).toFixed(1),
          ),
        );
        setHdpi(100);
        setWdpi(100);
        setRatio(
          Number(((Number(c.width) * 2.54) / 100).toFixed(1)) /
            Number(((Number(c.height) * 2.54) / 100).toFixed(1)),
        );
      }
    }
  };
  const submitHandler = async () => {
    const pic1: any = document.getElementById("userArtwork");

    if (pic1 && crop && crop.width && crop.height) {
      // Create a canvas element
      setWidthError("");
      setHeightError("");
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Set canvas dimensions to the crop dimensions
      canvas.width = crop.width;
      canvas.height = crop.height;

      // Calculate scale based on original pic1 dimensions
      const scaleX = pic1.naturalWidth / pic1.width;
      const scaleY = pic1.naturalHeight / pic1.height;

      // Draw the cropped area onto the canvas
      if (ctx && crop)
        ctx.drawImage(
          pic1,
          crop.x * scaleX,
          crop.y * scaleY,
          crop.width * scaleX,
          crop.height * scaleY,
          0,
          0,
          crop.width,
          crop.height,
        );

      // Convert canvas to a base64 picture URL
      const base64Image = canvas.toDataURL("image/jpeg");

      // Set the result state to display or use later
      setResult(base64Image);

      // Optionally, upload to Parse Server
      await uploadCroppedImage(base64Image);
    } else {
      setWidthError("Please select part of your picture");
    }
  };
  const uid = function () {
    return (
      Date.now().toString(36) +
      Math.floor(
        Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12),
      ).toString(36)
    );
  };
  const guestId = localStorage.getItem("guestId")
    ? localStorage.getItem("guestId")
    : uid();
  const uploadCroppedImage = async (base64Image: RequestInfo | URL) => {
    setUploadLoading(true);

    try {
      const response = await fetch(base64Image);
      const blob = await response.blob();
      const file = new Parse.File(`cropped-${title}.jpg`, blob);
      await file.save();

      const query = new Parse.Query("UserArtwork");
      const artwork = await query.get(
        String(localStorage.getItem("uploadImageId")),
      );

      artwork.set("resizedImage", file);
      await artwork.save();

      console.log("Cropped image uploaded successfully!", artwork.id);
      if (frame !== "No Frame") {
        localStorage.setItem("inputWidth", String(inputWidth));
        localStorage.setItem("inputHeight", String(inputHeight));
        localStorage.setItem("framingMode", "user");
        localStorage.setItem("selectedPaper", String(selectedPaper));

        navigate("/online-framing/new");
      } else {
        const user = Parse.User.current();
        if (user)
          await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: String(localStorage.getItem("uploadImageId")),
            quantity: 1,
            frameId: "",
            specifications: {
              width: inputWidth,
              height: inputHeight,
              paper: selectedPaper,
              mountboard: {},
            },
            type: "UserArtwork",
            itemId: localStorage.getItem("editItemId")
              ? localStorage.getItem("editItemId")
              : "",
          });
        else {
          await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: String(localStorage.getItem("uploadImageId")),
            quantity: 1,
            frameId: "",
            specifications: {
              width: inputWidth,
              height: inputHeight,
              paper: selectedPaper,
              mountboard: {},
            },
            type: "UserArtwork",
            itemId: localStorage.getItem("editItemId")
              ? localStorage.getItem("editItemId")
              : "",
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
        if (localStorage.getItem("editItemId")) {
          localStorage.removeItem("editItemId");
          navigate("/cart");
        }
      }
    } catch (error) {
      console.error("Error uploading cropped image:", error);
    } finally {
      setUploadLoading(false);
    }
  };

  const widthChangeHandler = (event: any) => {
    if (!isNaN(event.target.value)) setInputWidth(event.target.value);

    setWidthError("");
    if (isNaN(event.target.value))
      setWidthError("Make sure you are inputting numbers!");
    else if (event.target.value % 1 !== 0 && event.target.value % 1 !== 0.5)
      setWidthError("Round the values to the nearest 0.5cm");
    else if (event.target.value < 5)
      setWidthError(
        "Think bigger! Your artwork must be at least 5×5cm to be displayed",
      );
    else if (event.target.value > 60)
      setWidthError("Too grand for delivery! Max size allowed is 60×60cm");
    else {
      const pic1: any = document.getElementById("userArtwork");
      const width = pic1.width;
      const height = pic1.height;
      setInputWidth(parseInt(event.target.value));
      setRatio(parseInt(event.target.value) / inputHeight);
      setWdpi(Number(((width * 2.54) / event.target.value).toFixed(0)));
      if (!forceFit) {
        if (width > height) {
          if ((event.target.value * height) / inputHeight <= width) {
            setCrop({
              unit: "px", // Can be 'px' or '%'
              x: (width - (event.target.value * height) / inputHeight) / 2,
              y: 0,
              width: (event.target.value * height) / inputHeight,
              height: height,
            });
          } else {
            setCrop({
              unit: "px", // Can be 'px' or '%'
              x: 0,
              y: (height - (inputHeight * width) / event.target.value) / 2,
              width: width,
              height: (inputHeight * width) / event.target.value,
            });
          }
        } else {
          if ((inputHeight * width) / event.target.value <= height) {
            setCrop({
              unit: "px", // Can be 'px' or '%'
              x: 0,
              y: (height - (inputHeight * width) / event.target.value) / 2,
              width: width,
              height: (inputHeight * width) / event.target.value,
            });
          } else {
            setCrop({
              unit: "px", // Can be 'px' or '%'
              x: (width - (event.target.value * height) / inputHeight) / 2,
              y: 0,
              width: (event.target.value * height) / inputHeight,
              height: height,
            });
          }
        }

        setWidthError("");
      }
    }
  };
  const heightChangeHandler = (event: any) => {
    if (!isNaN(event.target.value)) setInputHeight(event.target.value);
    setHeightError("");
    if (isNaN(event.target.value))
      setHeightError("Make sure you are inputting numbers!");
    else if (event.target.value % 1 !== 0 && event.target.value % 1 !== 0.5)
      setHeightError("Round the values to the nearest 0.5cm");
    else if (event.target.value < 5)
      setHeightError(
        "Think bigger! Your artwork must be at least 5×5cm to be displayed",
      );
    else if (event.target.value > 60)
      setHeightError("Too grand for delivery! Max size allowed is 60×60cm");
    else {
      const pic1: any = document.getElementById("userArtwork");
      const width = pic1.width;
      const height = pic1.height;
      setInputHeight(parseInt(event.target.value));
      setRatio(inputWidth / parseInt(event.target.value));
      setHdpi(Number(((height * 2.54) / event.target.value).toFixed(0)));
      if (!forceFit) {
        if (width > height) {
          if ((inputWidth * height) / event.target.value <= width) {
            setCrop({
              unit: "px", // Can be 'px' or '%'
              x: (width - (inputWidth * height) / event.target.value) / 2,
              y: 0,
              width: (inputWidth * height) / event.target.value,
              height: height,
            });
          } else {
            setCrop({
              unit: "px", // Can be 'px' or '%'
              x: 0,
              y: (height - (event.target.value * width) / inputWidth) / 2,
              width: width,
              height: (event.target.value * width) / inputWidth,
            });
          }
        } else {
          if ((event.target.value * width) / inputWidth <= height) {
            setCrop({
              unit: "px", // Can be 'px' or '%'
              x: 0,
              y: (height - (event.target.value * width) / inputWidth) / 2,
              width: width,
              height: (event.target.value * width) / inputWidth,
            });
          } else {
            setCrop({
              unit: "px", // Can be 'px' or '%'
              x: (width - (inputWidth * height) / event.target.value) / 2,
              y: 0,
              width: (inputWidth * height) / event.target.value,
              height: height,
            });
          }
        }
        setHeightError("");
      }
    }
  };
  const imgLoadHandler = (event: any) => {
    setCrop({
      unit: "px", // Can be 'px' or '%'
      x: 0,
      y: 0,
      width: event.target.width,
      height: event.target.height,
    });
    setWidthRealFactor(userArtwork.get("width") / event.target.width);
    setHeightRealFactor(userArtwork.get("height") / event.target.height);

    // setInputHeight(
    //   Number(((Number(userArtwork.get("height")) * 2.54) / 100).toFixed(1))
    // );

    // setInputWidth(
    //   Number(((Number(userArtwork.get("width")) * 2.54) / 100).toFixed(1))
    // );
    // setRatio(
    //   Number(((Number(userArtwork.get("width")) * 2.54) / 100).toFixed(1)) /
    //     Number(((Number(userArtwork.get("height")) * 2.54) / 100).toFixed(1))
    // );
  };
  const [forceFit, setForceFit] = useState(false);
  const fitHandler = (event: any) => {
    // console.log(event.target.checked);
    setForceFit(event.target.checked);
  };
  return (
    <Fragment>
      <Container sx={{ my: 3 }}>
        <Typography variant="h4" sx={{ textAlign: "center" }} component="h2">
          Lets view your image
        </Typography>
        <Typography
          sx={{ color: "#949494", textAlign: "center", my: 2 }}
          variant="h6"
        >
          Please upload the highest resolution file you have for best results.
        </Typography>
        <Grid container>
          <Grid
            item
            xs={12}
            md={7}
            sx={{
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box className={styles.crop}>
              <ReactCrop
                crop={crop}
                onChange={cropHandler}
                minHeight={196.850393701 / heightRealFactor}
                minWidth={196.850393701 / widthRealFactor}
                maxHeight={35433.070866142}
                maxWidth={35433.070866142}
              >
                {fetchLoading ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <CircularProgress size="10rem" sx={{ color: "#8A3B1D" }} />
                    <Typography variant="h6">
                      Uploading your image...
                    </Typography>
                  </Box>
                ) : (
                  <img
                    src={pictureUrl}
                    alt={title}
                    style={{ maxHeight: "34rem", border: "2px solid black" }}
                    id="userArtwork"
                    crossOrigin="anonymous"
                    onLoad={imgLoadHandler}
                  />
                )}
              </ReactCrop>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} sx={{ paddingLeft: { xs: 0, md: 3 } }}>
            <Typography variant="h5" sx={{ marginBottom: 2 }}>
              Choose your print size
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box>
                <input
                  type="text"
                  className={styles.input}
                  defaultValue={inputWidth}
                  onChange={widthChangeHandler}
                  value={inputWidth}
                />
                <Typography sx={{ mx: 2, color: "#8b8b8b", display: "inline" }}>
                  x
                </Typography>
                <input
                  type="text"
                  className={styles.input}
                  onChange={heightChangeHandler}
                  defaultValue={inputHeight}
                  value={inputHeight}
                />
                <Typography sx={{ mx: 2, color: "#8b8b8b", display: "inline" }}>
                  cm
                </Typography>
              </Box>
              <Typography sx={{ display: "inline", color: "#949494" }}>
                DPI at this size:{" "}
                {wdpi !== 0 && hdpi !== 0 ? Math.min(wdpi, hdpi) : "?"}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  pt: 2,
                }}
              >
                <Checkbox
                  sx={{
                    color: "#863a18",
                    "&.Mui-checked": { color: "#863a18" },
                    p: 0,
                    mr: 2,
                  }}
                  onChange={fitHandler}
                />
                <Typography>Force to fit</Typography>
              </Box>
              {forceFit && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    pt: 2,
                    gap: 2,
                  }}
                >
                  <Typography>Distortion Rate:</Typography>
                  {(
                    (inputWidth * crop.height) /
                    (inputHeight * crop.width)
                  ).toFixed(2)}
                </Box>
              )}
            </Box>
            {forceFit && (
              <Typography sx={{ mt: 1, ml: 5.5 }}>
                Values closer to 1 reduces distortion
              </Typography>
            )}
            <Box sx={{ height: "1.5rem", my: 1 }}>
              {widthError ? (
                <Typography sx={{ color: "red" }}>{widthError}</Typography>
              ) : heightError ? (
                <Typography sx={{ color: "red" }}>{heightError}</Typography>
              ) : (
                Math.min(wdpi, hdpi) < 50 && (
                  <Typography sx={{ color: "#863a18" }}>
                    Warning: DPI below 50 can cause pixellation.
                  </Typography>
                )
              )}
            </Box>
            {/* {width &&
              height &&
              inputWidth > 0 &&
              inputWidth > 0 &&
              Math.abs(width / height - inputWidth / inputHeight) > 0.3 && (
                <Typography sx={{ mt: 1 }}>
                  Your inputs do not match your image's aspect ratio!
                </Typography>
              )} */}
            <Typography variant="h5" sx={{ marginTop: 4, marginBottom: 2 }}>
              Paper Choice
            </Typography>
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 2,
              }}
            >
              <Grid
                item
                xs={12}
                sm={5.5}
                sx={{
                  border: "2px solid #d0cece",
                  borderRadius: "10px",
                  position: "relative",
                  backgroundColor: `${
                    selectedPaper === "Satin Photo Paper" ? "#fafafa" : "white"
                  }`,
                  transition: "all 500ms",
                  mb: 1,
                }}
              >
                <div
                  className="glass-item"
                  onClick={paperChangeHandler}
                  id="Satin Photo Paper"
                >
                  <Typography id="Satin Photo Paper">
                    Satin Photo Paper
                  </Typography>
                  <Typography sx={{ color: "#949494" }} id="Satin Photo Paper">
                    Canson Acid-free Archival 270 gsm.
                    <br /> Ideal for photographs
                  </Typography>
                </div>

                <CheckCircleOutlineIcon
                  sx={{
                    position: "absolute",
                    right: "-15px",
                    top: "-15px",
                    color: "#863a18",
                    backgroundColor: "white",
                    borderRadius: "100%",
                    fontSize: "35px",
                    opacity: `${
                      selectedPaper === "Satin Photo Paper" ? "1" : "0"
                    }`,
                    transition: "all 500ms",
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={5.5}
                sx={{
                  border: "2px solid #d0cece",
                  borderRadius: "10px",
                  position: "relative",
                  backgroundColor: `${
                    selectedPaper === "Matte Photo Paper" ? "#fafafa" : "white"
                  }`,
                  transition: "all 500ms",
                  mb: 1,
                }}
              >
                <div
                  className="glass-item"
                  onClick={paperChangeHandler}
                  id="Matte Photo Paper"
                >
                  <Typography id="Matte Photo Paper">
                    Matte Photo Paper
                  </Typography>
                  <Typography sx={{ color: "#949494" }} id="Matte Photo Paper">
                    Indigo Photomatte 180 gsm. <br />
                    Ideal for posters
                  </Typography>
                </div>

                <CheckCircleOutlineIcon
                  sx={{
                    position: "absolute",
                    right: "-15px",
                    top: "-15px",
                    color: "#863a18",
                    backgroundColor: "white",
                    borderRadius: "100%",
                    fontSize: "35px",
                    transition: "all 500ms",
                    opacity: `${
                      selectedPaper === "Matte Photo Paper" ? "1" : "0"
                    }`,
                  }}
                />
              </Grid>
            </Grid>

            {!localStorage.getItem("editItemId") && (
              <Fragment>
                <Typography variant="h5" sx={{ marginTop: 4, marginBottom: 2 }}>
                  Frame
                </Typography>
                <Grid
                  container
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    marginTop: 2,
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={5.5}
                    sx={{
                      border: "2px solid #d0cece",
                      borderRadius: "10px",
                      position: "relative",
                      backgroundColor: `${
                        frame === "No Frame" ? "#fafafa" : "white"
                      }`,
                      transition: "all 500ms",
                      mb: 1,
                    }}
                  >
                    <div
                      className="glass-item"
                      onClick={frameChangeHandler}
                      id="No Frame"
                    >
                      <Typography id="No Frame">No Frame</Typography>
                    </div>

                    <CheckCircleOutlineIcon
                      sx={{
                        position: "absolute",
                        right: "-15px",
                        top: "-15px",
                        color: "#863a18",
                        backgroundColor: "white",
                        borderRadius: "100%",
                        fontSize: "35px",
                        opacity: `${frame === "No Frame" ? "1" : "0"}`,
                        transition: "all 500ms",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={5.5}
                    sx={{
                      border: "2px solid #d0cece",
                      borderRadius: "10px",
                      position: "relative",
                      backgroundColor: `${
                        frame === "Add Frame" ? "#fafafa" : "white"
                      }`,
                      transition: "all 500ms",
                      mb: 1,
                    }}
                  >
                    <div
                      className="glass-item"
                      onClick={frameChangeHandler}
                      id="Add Frame"
                    >
                      <Typography id="Add Frame">Add Frame</Typography>
                    </div>

                    <CheckCircleOutlineIcon
                      sx={{
                        position: "absolute",
                        right: "-15px",
                        top: "-15px",
                        color: "#863a18",
                        backgroundColor: "white",
                        borderRadius: "100%",
                        fontSize: "35px",
                        transition: "all 500ms",
                        opacity: `${frame === "Add Frame" ? "1" : "0"}`,
                      }}
                    />
                  </Grid>
                </Grid>
              </Fragment>
            )}

            <Box
              sx={{ marginTop: 4, display: "flex", justifyContent: "center" }}
            >
              <button
                className={
                  widthError.length > 0 || heightError.length > 0
                    ? styles["button-disable"]
                    : styles["button"]
                }
                onClick={submitHandler}
                disabled={widthError.length > 0 || heightError.length > 0}
              >
                {uploadLoading ? (
                  <CircularProgress
                    size="2rem"
                    sx={{ color: "white", m: 0, p: 0 }}
                  />
                ) : localStorage.getItem("editItemId") ? (
                  "Edit item"
                ) : frame === "No Frame" ? (
                  `₤${
                    pricing &&
                    (
                      (2e-16 *
                        Math.pow(
                          Number(
                            inputWidth *
                              inputHeight *
                              Number(pricing.get("paper_cm2")),
                          ),
                          4,
                        ) +
                        1e-11 *
                          Math.pow(
                            Number(
                              inputWidth *
                                inputHeight *
                                Number(pricing.get("paper_cm2")),
                            ),
                            3,
                          ) -
                        1e-7 *
                          Math.pow(
                            Number(
                              inputWidth *
                                inputHeight *
                                Number(pricing.get("paper_cm2")),
                            ),
                            2,
                          ) +
                        0.0117 *
                          Number(
                            inputWidth *
                              inputHeight *
                              Number(pricing.get("paper_cm2")),
                          ) +
                        3.5525) *
                      (pricing.get("VAT") + 1)
                    )
                      // * pricing.get("multiplierFactor")
                      .toFixed(2)
                  }-Add to Cart`
                ) : (
                  "Start framing"
                )}
              </button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};

export default OnlinePrinting;

// min 5cm
// Max 60cm

// Faam Gallery
// Warning: DPI below 50 can cause pixellation.
